import Colors from './components/Colors/Colors';
import Fonts from './components/Fonts/Fonts';
import IntroOutro from './components/IntroOutro/IntroOutro';
import TemplateBackground from './components/TemplateBackground/TemplateBackground';
import BrandTone from './components/BrandTone/BrandTone';
import { BrandKitConfigItem } from './types';

export const BRAND_KIT_DEFAULT_CONFIGURATION: Record<string, BrandKitConfigItem> = {
  brand_tone: {
    title: 'Voice Profile',
    description: 'Customize our AI to to match your style and tone',
    renderer: <BrandTone />
  },
  colors: {
    title: 'Color',
    description: 'Add your brand colors and use them in your clips',
    renderer: <Colors />
  },
  fonts: {
    title: 'Font',
    description: 'Add custom fonts and use them in captions and speaker labels',
    renderer: <Fonts />
  },
  background: {
    title: 'Template Background',
    description: 'Use a custom template background to brand your clips',
    renderer: <TemplateBackground />
  },
  intro_outro: {
    title: 'Intro/Outro Video',
    description: 'Add short, branded intro or outro videos to use with your clips',
    renderer: <IntroOutro />
  }
};
